import type { OTCDealData } from '@src/types/OTC';
import { getOtcDealQuantityDisplayValue } from '@src/utils/OTC/otcDealDisplayUtils';
import { InlineFormattedNumber } from '@talos/kyoko';

interface QuantityDisplayProps {
  instrumentData: OTCDealData;
}

export const QuantityDisplay = ({ instrumentData }: QuantityDisplayProps) => {
  const { value, currency } = getOtcDealQuantityDisplayValue(instrumentData);
  return (
    <InlineFormattedNumber
      data-testid="instrument-inspector-section-field-value"
      number={value}
      currency={currency}
      background="backgroundBlotterTableRowHover"
    />
  );
};
